const Loader = () => {
    return (
        <div className="h-[250px] min-w-[30vw] w-full flex items-center justify-center">
            <p>Loading...</p>
        </div>
    )
}

export default Loader